<template>
    <div>
        <svg :width="iconSize" :height="iconSize" viewBox="0 0 21 21" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
                d="M8.89959 7.11069C9.13626 6.92268 9.4174 6.78595 9.71875 6.70051V9.61192C9.41164 9.52472 9.13128 9.38586 8.89959 9.20181C8.48945 8.876 8.33075 8.49266 8.33075 8.15625C8.33075 7.81984 8.48945 7.4365 8.89959 7.11069Z"
                :fill="color" 
            />
            <path
                d="M11.2812 14.3142V11.3733C11.643 11.4612 11.9727 11.6102 12.241 11.8114C12.6852 12.1446 12.8438 12.5259 12.8438 12.8437C12.8438 13.1616 12.6852 13.5428 12.241 13.876C11.9727 14.0772 11.643 14.2262 11.2812 14.3142Z"
                :fill="color" 
            />
            <path fill-rule="evenodd" clip-rule="evenodd"
                d="M10.5 0.34375C4.89086 0.34375 0.34375 4.89086 0.34375 10.5C0.34375 16.1091 4.89086 20.6562 10.5 20.6562C16.1091 20.6562 20.6562 16.1091 20.6562 10.5C20.6562 4.89086 16.1091 0.34375 10.5 0.34375ZM11.2812 4.25C11.2812 3.81853 10.9315 3.46875 10.5 3.46875C10.0685 3.46875 9.71875 3.81853 9.71875 4.25V5.09961C9.06573 5.2153 8.44305 5.47785 7.92769 5.88725C7.18565 6.47672 6.76825 7.29302 6.76825 8.15625C6.76825 9.01948 7.18565 9.83577 7.92769 10.4253C8.45108 10.841 9.07569 11.099 9.71875 11.2128V14.3141C9.35712 14.2262 9.0275 14.0772 8.75925 13.876L7.84376 13.1894C7.49859 12.9305 7.0089 13.0004 6.75001 13.3456C6.49112 13.6908 6.56107 14.1805 6.90624 14.4393L7.82173 15.126C8.37715 15.5426 9.03952 15.7975 9.71875 15.9066V16.75C9.71875 17.1815 10.0685 17.5312 10.5 17.5312C10.9315 17.5312 11.2812 17.1815 11.2812 16.75V15.9066C11.9606 15.7975 12.623 15.5426 13.1785 15.126C13.9546 14.5439 14.4062 13.7255 14.4062 12.8437C14.4062 11.9619 13.9546 11.1436 13.1785 10.5614C12.623 10.1448 11.9606 9.88992 11.2812 9.78082V6.70059C11.5825 6.78604 11.8635 6.92274 12.1001 7.11069L12.5323 7.45401C12.8701 7.7224 13.3616 7.66609 13.63 7.32824C13.8984 6.9904 13.842 6.49895 13.5042 6.23057L13.072 5.88725C12.5567 5.47791 11.9342 5.21538 11.2812 5.09966V4.25Z"
                :fill="color" 
            />
        </svg>
    </div>
</template>

<script>
export default {
    name: 'IconSvgDollar',
    props: {
        color: {
            type: String,
            default: '#000000',
        },
        size: {
            type: Number,
            default: null
        }
    },
    computed: {
        iconSize() {
            return this.size ? `${this.size}px` : '44px'
        }
    }
};
</script>

<style scoped></style>